import { createContext, SetStateAction, useContext, useState } from "react";

type HomeModalType =
      undefined
    | "AddAccountGroup" // 新規口座グループ追加
    | "SelectAccounts" // 認可後口座選択
    | "AddAccountInfo" // 口座情報入力
    | "ConfirmAddAccountInfo" // 口座情報入力継続確認
    // お知らせ
    | "News" // お知らせ一覧
    // アカウント設定関連モーダル
    | "Settings" // 設定メニュー
    | "UserInfo" // ユーザー情報変更
    | "UserInfoComplete" // ユーザー情報変更完了
    | "UserId" // ユーザーID変更
    | "UserPassword" // ユーザーパスワード変更
    | "UserPasswordComplete" // ユーザーパスワード変更完了
    | "MailSettings" // メールの配信設定
    | "TwoStepAuth" // 2段階認証設定
    | "TwoStepAuthSetCode" // 2段階認証設定コード入力
    | "TwoStepAuthComplete" // 2段階認証設定完了
    | "UsersIntegrationInput" // ユーザー統合のID/PW入力
    | "UsersIntegrationConfirm" // ユーザー統合の確定
    | "UsersIntegrationCompleted" // ユーザー統合の完了
    | "CloudIntegration" // Kクラ・商クラ連携設定
    | "LoginHistory" // ログイン履歴
    | "DeleteUser" // 利用者削除
    | "MailSend" // メール送信完了メッセージ
    // グループ招待
    | "ShareInvited" // 共有招待
    // 口座追加関連モーダル
    | "AddNewAccounts" // 新規口座追加
    | "SelectInstitutions" // 金融機関選択（銀行、クレカ、電マネ、ECショップ）
    | "OcrAccount" // OCR口座
    | "SelectOcrAggregateType" // OCR取込タイプ選択
    | "OcrFileAggregate" // OCRファイル取込
    | "OcrCameraAggregate" // OCRカメラ取込
    | "SelectCsvInstitution" // CSV口座の金融機関選択
    | "SelectExcelProcess" // Excel用Web明細帳作成
    | "RegisterCsvAccount" // CSV口座の登録
    | "RegisterExcelAccount" // Excel口座の登録
    | "DownloadExcelTemplate" // Excelテンプレートダウンロード
    | "UploadCsv" // CSVファイルアップロード
    | "UploadExcel" // Excelファイルアップロード
    | "FirstUploadCsv" // CSVファイルアップロード（口座登録時）
    | "FirstUploadExcel" // Excelファイルアップロード（口座登録時）
    | "Service" // 金融機関サービス選択(銀行、クレカ、電子マネー、ECショップ)
    | "SiteAuth" // 認可画面遷移確認(銀行、クレカAPI、LookAPI、ECショップ)
    | "SiteReauth" // 認可画面遷移(再認可)確認(銀行、クレカAPI、LookAPI、ECショップ)
    | "ReauthCompleted" // 再認可完了
    | "PaymentLoginInfo" // ログイン情報入力(Lookスクレイピング)
    | "Otp" // ワンタイムパスワード入力(Lookスクレイピング)
    | "DuplicateTrades" // 期間重複明細取込方法の選択
    // 明細一覧画面モーダル
    | "Memo" // 明細メモ
    | "ConditionalSearch" // 明細検索
    | "AddTrades" // CSV/Excel明細追加
    | "AddOcrTrades" // OCR読み込み(ファイルから)
    | "Camera" // OCR読み込み(カメラ撮影)
    | "CheckOcr" // OCR明細確認
    | "OcrProcess" // OCR読み取り状況
    | "OcrImageDelete" // OCR画像削除確認
    | "Option" // その他機能
    | "Download" // 明細ダウンロード
    | "SyncAccountsStart" // 口座追加(同期処理)開始
    | "SyncOtp" // ワンタイムパスワード入力(同期処理)
    | "SyncAccounts" // 口座追加(同期処理)
    | "History" // 取引履歴
    | "EditName" // 口座名編集
    | "Delete" // 口座削除
    | "UpdateTrades" // 明細更新
    | "UpdateTradesOtp"; // ワンタイムパスワード入力(明細更新)

type MyDataModalType =
      undefined
    // お知らせ
    | "News" // お知らせ一覧
    // アカウント設定関連モーダル
    | "Settings" // 設定メニュー
    | "UserInfo" // ユーザー情報変更
    | "UserId" // ユーザーID変更
    | "UserPassword" // ユーザーパスワード変更
    | "TwoStepAuth" // 2段階認証設定
    | "CloudIntegration" // Kクラ・商クラ連携設定
    | "LoginHistory" // ログイン履歴
    | "DeleteUser" // 利用者削除
    | "MailSend" // メール送信完了メッセージ
    // グループ招待
    | "ShareInvited" // 共有招待
    // 口座グループ編集関連モーダル
    | "GroupMenu" // 口座グループメニュー
    | "UpdateName" // 口座グループ名変更
    | "SelectMoveGroup" // 移動口座グループ選択
    | "MoveGroup" // 口座グループ移動実行
    | "ServiceIntegration" // サービス連携設定
    | "ConnectService" // サービス連携
    | "DisconnectConfirmModal" // サービス連携解除確認
    | "Share" // 口座グループ共有
    | "ShareMember" // 口座グループ共有メンバー一覧
    | "ShareMemberCancelConfirm" // 共有/招待取り消し確認
    | "SendShareMail" // 口座グループ共有用メール送信完了
    | "ExcelDownload" // 口座グループまとめてダウンロード
    | "Delete" // 口座グループ削除
    | "ConnectDisconnectCompleted"; // サービス連携/解除完了確認

type NotLoginModalType =
      undefined
    // ログイン画面
    | "TwoStepAuthCode" // 2段階認証コード入力
    | "TwoStepAuthReleaseCode" // 2段階認証解除コード入力
    | "NotConverted" // データ移行未完了
    | "ConfirmNotConvert" // データ移行未実行確認
    | "FirstAuth"; // 初回認証疎通設定

interface ModalContextType {
  openHomeModal: HomeModalType;
  openMyDataModal: MyDataModalType;
  openNotLoginModal: NotLoginModalType;
  keepModal: boolean;
  // keepModalについて
  // ■用途
  // 画面描画直後のユーザ情報(ソリID、Kクラ連携フラグ)取得時に、BroadcastChannelで取得情報を他のタブに送信している。
  // これによりソリID、Kクラ連携フラグが更新されれば、別タブで異なるユーザ情報のアカウントが起動したと検知できる。
  // 検知した際は、画面同期処理を行い、その一環として現在表示中のモーダルをリセットしている。("@/features/home/index" 参照)
  // リダイレクト後の画面描画など、特定のモーダル表示とともにユーザ情報更新(初期値から現在のユーザ情報への更新)する際は、このリセット処理を行いたくないため、その制御用のフラグとして使用。
  setOpenHomeModal: React.Dispatch<SetStateAction<HomeModalType>>;
  setOpenMyDataModal: React.Dispatch<SetStateAction<MyDataModalType>>;
  setOpenNotLoginModal: React.Dispatch<SetStateAction<NotLoginModalType>>;
  setKeepModal: React.Dispatch<SetStateAction<boolean>>;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({children}: {children: React.ReactNode}) => {
  const [openHomeModal, setOpenHomeModal] = useState<HomeModalType>(undefined);
  const [openMyDataModal, setOpenMyDataModal] = useState<MyDataModalType>(undefined);
  const [openNotLoginModal, setOpenNotLoginModal] = useState<NotLoginModalType>(undefined);
  const [keepModal, setKeepModal] = useState<boolean>(false);

  return (
    <ModalContext.Provider
      value={{
        openHomeModal,
        openMyDataModal,
        openNotLoginModal,
        keepModal,
        setOpenHomeModal,
        setOpenMyDataModal,
        setOpenNotLoginModal,
        setKeepModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error("ModalContext must be used within ModalProvider");
  return context;
};